var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import classnames from 'classnames';
import { st, classes } from './Card.st.css';
import { CardDataHooks, CardDataKeys, } from './types';
var Container = function (props) {
    var className = props.className, children = props.children, minWidth = props.minWidth;
    return (React.createElement("div", { style: { flexBasis: minWidth }, className: classnames(classes.container, classes.overrideStyleParams, className), "data-hook": props['data-hook'] || CardDataHooks.CardContainer }, children));
};
/** An implementation of Card for TPAs */
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Card.prototype.getDataAttributes = function () {
        var _a;
        var stacked = this.props.stacked;
        return _a = {},
            _a[CardDataKeys.Stacked] = stacked,
            _a;
    };
    Card.prototype.render = function () {
        var _a = this.props, stacked = _a.stacked, children = _a.children, className = _a.className;
        return (React.createElement("section", __assign({ "data-hook": this.props['data-hook'], className: st(classes.root, { stacked: stacked }, className) }, this.getDataAttributes()), children));
    };
    Card.displayName = 'Card';
    Card.defaultProps = {
        stacked: false,
    };
    Card.Container = Container;
    return Card;
}(React.Component));
export { Card };
//# sourceMappingURL=Card.js.map